import { render, staticRenderFns } from "./UnifiedArea.vue?vue&type=template&id=1fbe1bca&scoped=true"
import script from "./UnifiedArea.vue?vue&type=script&lang=js"
export * from "./UnifiedArea.vue?vue&type=script&lang=js"
import style0 from "./UnifiedArea.vue?vue&type=style&index=0&id=1fbe1bca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbe1bca",
  null
  
)

export default component.exports